import { t } from "i18next";

import { nonFutureDateTimeSchema, shortTextSchema } from "@thalamos/common";

import { FieldBuilder } from "../../formBuilder/FieldBuilder.js";
import { MultiPageFormBuilder } from "../../formBuilder/MultiPageFormBuilder.js";
import { tk } from "../../types/Translation.js";

export const formSpecification = new MultiPageFormBuilder()
  .withFieldAlwaysVisible({
    fieldName: "user",
    type: "textbox",
    ...new FieldBuilder().withSchema(shortTextSchema).build(),
    label: tk("s136FormRejected.user"),
  })
  .withFieldAlwaysVisible({
    fieldName: "userEmail",
    type: "textbox",
    ...new FieldBuilder().withSchema(shortTextSchema).build(),
    label: tk("s136FormRejected.email"),
  })
  .withFieldAlwaysVisible({
    fieldName: "reason",
    type: "textbox",
    ...new FieldBuilder().withSchema(shortTextSchema).build(),
    label: tk("s136FormRejected.reason"),
  })
  .withFieldAlwaysVisible({
    fieldName: "s136FormRejectedAt",
    type: "date-time",
    ...new FieldBuilder().withSchema(nonFutureDateTimeSchema).build(),
    dateLabel: tk("s136FormRejected.rejectedDateTime"),
    timeLabel: tk("s136FormRejected.rejectedDateTime"),
    disableFuture: true,
  })
  .withPage(["user", "userEmail", "reason", "s136FormRejectedAt"])
  .build({ t });

export type S136FormRejectedFormData = ReturnType<
  typeof formSpecification
>["formType"];
